import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/api';
import { Link } from "react-router-dom";

import './ProductList.css';
import Layout from '../components/Layout';

const ProductList = ({onCartUpdate}) => {
    const [products, setProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const navigate = useNavigate();

    const productsPerPage = 12; // Số sản phẩm mỗi trang
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        // Kiểm tra trạng thái đăng nhập
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token); // Nếu có token => đăng nhập

        // Gọi API để lấy sản phẩm
        const fetchProducts = async () => {
            try {
                const response = await axios.get('/products/products_to_show', {
                    params: {
                        page: currentPage,
                        limit: productsPerPage,
                        sort: 'code', // Sắp xếp theo mã sản phẩm
                        search: searchTerm, // Tìm kiếm theo tên sản phẩm
                    },
                });

                setProducts(response.data.products);
                setTotalPages(response.data.totalPages);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchProducts();
    }, [currentPage, searchTerm]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset về trang đầu khi tìm kiếm
    };

    /*const handleAddToCart = async (product) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            await axios.post('/carts/add', {
                productId: product._id,
                quantity: 1,
                price: product.price,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            alert('Sản phẩm đã được thêm vào giỏ hàng.');
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    };*/
    const handleAddToCart = async (product) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            await axios.post(
                '/carts/add',
                {
                    productId: product._id,
                    quantity: 1,
                    price: product.price,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            // Gọi API để lấy số lượng sản phẩm mới trong giỏ
            const response = await axios.get('/carts/count', {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (onCartUpdate) {
                onCartUpdate(response.data.count || 0);
            }

            alert('Sản phẩm đã được thêm vào giỏ hàng.');
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    };



    const handleCheckout = async (product) => {
        try {
            await handleAddToCart(product);
            navigate('/cart'); // Chuyển hướng đến trang giỏ hàng
        } catch (error) {
            console.error('Error during checkout:', error);
        }
    };

    return (
        <Layout>
            <div className="product-list-container" style={{ backgroundColor: 'white', minHeight: '100vh', padding: '20px' }}>
                <h1 className="product-list-title">Danh Sách Sản Phẩm</h1>

                {/* Thanh tìm kiếm */}
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Tìm kiếm sản phẩm..."
                        value={searchTerm}
                        onChange={handleSearch}
                        className="form-control"
                    />
                </div>

                {/* Danh sách sản phẩm */}
                <div className="products-grid">
                    {products.map((product) => (
                        <div key={product._id} className="product-item">
                            <div className="product-image">
                                <img
                                    src={`${process.env.REACT_APP_API_BASE_URL}${product.urlProductThumbnail}`}
                                    alt={product.name}
                                />
                            </div>
                            <div className="product-details">
                                <h3>
                                    <Link to={`/products/${product._id}`}>{product.name}</Link>
                                </h3>
                                <p>Mã sản phẩm: {product.code}</p>
                                <p>Giá: {product.price.toLocaleString()} VND</p>
                                <p>Loại: {product.category}</p>
                                {isLoggedIn ? (
                                    <div className="action-buttons">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={() => handleAddToCart(product)}
                                        >
                                            Đưa vào giỏ hàng
                                        </button>
                                        <button
                                            className="btn btn-success"
                                            onClick={() => handleCheckout(product)}
                                        >
                                            Đặt hàng
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        className="btn btn-warning"
                                        onClick={() => navigate('/login')}
                                    >
                                        Đăng nhập để đặt hàng
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Hiển thị phân trang */}
                <div className="pagination">
                    {[...Array(totalPages)].map((_, index) => (
                        <button
                            key={index}
                            onClick={() => handlePageChange(index + 1)}
                            className={index + 1 === currentPage ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default ProductList;
